/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TermsConditions
 */
export interface TermsConditions {
    /**
     * 
     * @type {string}
     * @memberof TermsConditions
     */
    readonly id?: string;
    /**
     * 
     * @type {number}
     * @memberof TermsConditions
     */
    readonly number?: number;
    /**
     * 
     * @type {Date}
     * @memberof TermsConditions
     */
    readonly validFrom?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TermsConditions
     */
    readonly validUntil?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TermsConditions
     */
    readonly created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TermsConditions
     */
    readonly updated?: Date;
    /**
     * 
     * @type {string}
     * @memberof TermsConditions
     */
    readonly createdBy?: string;
    /**
     * 
     * @type {string}
     * @memberof TermsConditions
     */
    readonly updatedBy?: string;
}

/**
 * Check if a given object implements the TermsConditions interface.
 */
export function instanceOfTermsConditions(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TermsConditionsFromJSON(json: any): TermsConditions {
    return TermsConditionsFromJSONTyped(json, false);
}

export function TermsConditionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TermsConditions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'number': !exists(json, 'number') ? undefined : json['number'],
        'validFrom': !exists(json, 'validFrom') ? undefined : (new Date(json['validFrom'])),
        'validUntil': !exists(json, 'validUntil') ? undefined : (new Date(json['validUntil'])),
        'created': !exists(json, 'created') ? undefined : (new Date(json['created'])),
        'updated': !exists(json, 'updated') ? undefined : (new Date(json['updated'])),
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'updatedBy': !exists(json, 'updatedBy') ? undefined : json['updatedBy'],
    };
}

export function TermsConditionsToJSON(value?: TermsConditions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}

